import { useQuery } from '@tanstack/react-query';
import { mumulLiveService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';

/**
 * 무물라이브 프로필 상태 조회.
 * `enabled`(실험 노출 여부) 가 true 이고 `profileSno`(market.mumul_live_profile_sno)가
 * 있을 때만 호출한다.
 */
export const useMumulLiveProfileStatus = (
  profileSno: number | null,
  enabled = true,
) => {
  return useQuery({
    queryKey: queryKey.mumulLiveProfileStatus(profileSno ?? 0),
    queryFn: () =>
      mumulLiveService.getMumulLiveProfileStatus(profileSno as number),
    enabled: enabled && profileSno != null,
  });
};
